import { render, staticRenderFns } from "./SqlEditor.vue?vue&type=template&id=0d9ee561&scoped=true"
import script from "./SqlEditor.vue?vue&type=script&lang=js"
export * from "./SqlEditor.vue?vue&type=script&lang=js"
import style0 from "./SqlEditor.vue?vue&type=style&index=0&id=0d9ee561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9ee561",
  null
  
)

export default component.exports